export default {
    // aws config for beta
 
  };